import { css } from '@emotion/react';
import type { TemplatePreviewThemeValues } from './template-preview-theme';

export const templatePreviewStyle = ({ backgroundColor, borderRadius, spacing }: TemplatePreviewThemeValues) => css`
  background: ${backgroundColor};
  border-radius: ${borderRadius};
  padding: ${spacing(2)};
`;
